import { Component, OnInit } from '@angular/core';
import {NgForm} from "@angular/forms";
import {APIHelper} from "../../apihelper";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {SharedResources} from "../../shared-resources";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  rememberedUsername: string | null = '';

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    if (localStorage.getItem('username') != null) {
      this.rememberedUsername = localStorage.getItem('username');
    }
  }
  public login (form: NgForm) {
    const credentials = JSON.stringify(form.value);
    if (form.value.rememberMe) {
      localStorage.setItem('username', form.value.username);
    } else {
      localStorage.setItem('username', '');
    }
    this.http.post(`${APIHelper.APIUrl}login`, credentials, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    }).subscribe(
      response => {

        localStorage.setItem('token', (<any>response).token);
        localStorage.setItem('isAuth', 'true');
        localStorage.setItem('username', form.value.username);
        APIHelper._tokenBS.next(localStorage.getItem('token'));
        APIHelper._isAuthBS.next(true);
      }, error => {
        alert("Nume de utilizator sau parolă incorecte!");
        localStorage.setItem('token', '');
        localStorage.setItem('isAuth', 'false');
        APIHelper._tokenBS.next('');
        APIHelper._isAuthBS.next(false);
      }
    );
  }

  changeToForgotPassword() {

  }
}
